export default "__VITE_ASSET__55453d34__"